var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-list"},[_vm._t("title",function(){return [(_vm.title)?_c('h3',{staticClass:"link-list__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]}),_vm._l((_vm.links),function(link,index){return _c('div',{key:index},[_c('LinkBox',{attrs:{"link":link}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }